import axios from 'axios'

const state = {
  jobTypes: [],
  topicModelTypesDictionary: {},
  topicModelTypes: [],
  jobStatus: [],
  jobStatusDictionary: {},
  jobTypesDictionary: {},
  supportedLanguages: [],
  solrCoreNames: [],
  roles: {},
  authScopes: [],
  rawRoles: [],
  rawAuthScopes: [],
  version: '',
  annotationStatusDictionary: {},
  annotationStatus: [],
  annotationTypes: [
    {
      id: 0,
      name: 'Sentiment'
    },
    {
      id: 1,
      name: 'Topic'
    },
    {
      id: 2,
      name: 'Emotion'
    }
  ],
  annotationTypesDictionary: {},
  agreementLevelsDictionary: {},
  agreementLevels: [
    {
      id: 1,
      name: 'One annotator needs to be agreed'
    },
    {
      id: 2,
      name: 'Two annotators need to be agreed'
    },
    {
      id: 3,
      name: 'Three annotators need to be agreed'
    },
    {
      id: 4,
      name: 'Four annotators need to be agreed'
    }
  ]
}

const getters = {}

const actions = {
  getConfigurations ({commit}) {
    axios.get('/bootstrap')
      .then(result => {
        commit('setConfigurations', result.data)
      })
      .catch(error => {
        console.log(error)
      })
  }
}

const mutations = {
  setConfigurations (state, configurations) {
    state.version = configurations.version
    state.jobTypes = configurations.job_types
    state.jobTypesDictionary = configurations.job_types.reduce((map, obj) => {
      map[obj.id] = obj.name
      return map
    }, {})
    state.jobStatus = configurations.job_status
    state.jobStatusDictionary = configurations.job_status.reduce((map, obj) => {
      map[obj.id] = obj.name
      return map
    }, {})
    state.solrCoreNames = configurations.solr_core_names
    state.rawAuthScopes = configurations.auth_scopes
    state.authScopes = configurations.auth_scopes.reduce((map, obj) => {
      map[obj.id] = obj
      return map
    }, {})
    state.roles = configurations.roles.reduce((map, obj) => {
      map[obj.id] = obj
      return map
    }, {})
    state.rawRoles = configurations.roles
    state.supportedLanguages = []
    configurations.supported_languages.forEach(lang => {
      if (lang === 'tr') {
        state.supportedLanguages.push({
          value: lang,
          text: 'Turkish'
        })
      } else if (lang === 'en') {
        state.supportedLanguages.push({
          value: lang,
          text: 'English'
        })
      } else {
        state.supportedLanguages.push({
          value: lang,
          text: lang
        })
      }
    })
    state.annotationTypesDictionary = state.annotationTypes.reduce((map, obj) => {
      map[obj.id] = obj.name
      return map
    }, {})
    state.agreementLevelsDictionary = state.agreementLevels.reduce((map, obj) => {
      map[obj.id] = obj.name
      return map
    }, {})
    state.annotationStatusDictionary = configurations.annotation_status
    state.annotationStatus = Object.keys(configurations.annotation_status).map(k => {
      return {
        id: k,
        name: configurations.annotation_status[k]
      }
    })
    state.topicModelTypesDictionary = configurations.topic_model_types
    state.topicModelTypes = Object.keys(configurations.topic_model_types).map(k => {
      return {
        id: parseInt(k),
        name: configurations.topic_model_types[k]
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
